<template>
  <div class="chat_room_internet_apply_submit_wrap">
    <div class="chat_room_internet_apply_submit">
      <div class="a_title">인터넷 가입 신청서</div>
      <div class="a_con" v-if="applyAble">
        <div
          v-if="shopVouchersLimit && !isCustomer && !userApplyCancel"
          class="a_txt"
        >
          열람권을 이용하여<br />
          신청서를 확인해주세요.
        </div>
        <div
          v-else-if="
            shopVouchersLimit &&
              isCustomer &&
              applySubmitModel.promotionCode != 'KT2408' &&
              !userApplyCancel
          "
          class="a_txt"
        >
          매장에서 아직 <span class="rd">열람전</span>으로, 연락처를 묻거나
          연락을 달라하면 반드시 주의해주세요.
        </div>
        <div
          v-else-if="
            shopVouchersLimit &&
              isCustomer &&
              applySubmitModel.promotionCode == 'KT2408' &&
              !userApplyCancel
          "
          class="a_txt"
        >
          매장에서 아직 신청서를 열람하지 않았습니다.<br />매장 열람 후, 본인
          인증이 완료되면 접수가 진행됩니다.
        </div>
        <div v-else-if="!shopVouchersLimit && !isCustomer && !userApplyCancel">
          <div class="a_txt">
            고객님의 가입신청서가<br />도착했습니다.<br /><br />상세보기로 확인
            가능합니다.
          </div>
        </div>
        <div v-else-if="!shopVouchersLimit && isCustomer && !userApplyCancel">
          <div class="a_txt">
            고객님의 <br />가입신청서를 매장에서 확인 하였습니다.<br />상세보기로
            확인 가능합니다.
          </div>
        </div>
        <div v-else-if="isCustomer && userApplyCancel">
          <div class="a_txt">
            신청 취소가 완료되었습니다.<br />작성하신 개인정보는 폐기
            완료되었습니다.
          </div>
        </div>
        <div v-else-if="!isCustomer && userApplyCancel">
          <div class="a_txt">
            고객님이 신청서를 취소하였습니다.<br /><br />취소된 신청서는 열람할
            수 없습니다.
          </div>
        </div>
      </div>
      <div class="a_con" v-else>
        <div class="a_txt">비공개 전환 되었습니다.</div>
      </div>
    </div>
    <button
      class="btn bo"
      @click.stop.prevent="openApply()"
      v-if="isCustomer && !userApplyCancel"
    >
      상세 보기
    </button>
    <button
      class="btn bo"
      @click.stop.prevent="openAddress(applySubmitModel.applyId)"
      v-if="!isCustomer && shopVouchersLimit && !userApplyCancel"
      style="margin-bottom: 0.8rem"
    >
      주소 먼저 확인하기
    </button>
    <button
      class="btn bo"
      @click.stop.prevent="openVoucher(applySubmitModel.applyId)"
      v-if="!isCustomer && !userApplyCancel"
    >
      신청서 상세보기
    </button>
    <button
      class="chat_txt_btn"
      @click.stop.prevent="openApplyCancel(applySubmitModel.applyId)"
      v-if="isCustomer && shopVouchersLimit && !userApplyCancel"
    >
      <i class="ic_chat_btn_x_red"></i>신청 취소하기
    </button>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import {
  mapActions as mapInternetMapActions,
  mapGetters as mapInternetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

export default {
  props: {
    applySubmitModel: Object,
    chatroom: Object,
    applyCreatedAt: String,
    isCustomer: Boolean,
    // shopVouchersLimit: Boolean,
  },
  data() {
    return {
      applyAble: true, // 보름 후 비공개 처리 (true : 공개 / false : 비공개)
      shopVouchersLimit: true,
      userApplyCancel: false, // 신청서 취소 여부 ( true : 취소됨 / false : 취소안됨 )
    };
  },
  mounted() {},
  async created() {
    await this.getShopVouchersLimit(this.applySubmitModel.applyId);
    const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
    const createdAt = new Date(this.applyCreatedAt);

    const sDays = format(
      new Date(createdAt.setDate(createdAt.getDate() + 15)),
      'yyyy-MM-dd HH:mm:ss',
    );

    if (now > sDays) {
      this.applyAble = false;
    } else {
      this.applyAble = true;
    }
  },
  filters: {
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  methods: {
    ...mapInternetMapActions([internetTypes.SELECT_INTERNET_APPLY_CHECK_LIMIT]),
    toCurrency(val) {
      return util.toCurrency(val);
    },
    // 상세보기
    async openApply() {
      this.$router.push({
        name: 'InternetCommerce.ApplyDetail',
        params: {
          id: this.applySubmitModel.applyId,
          title: '인터넷 가입 신청서',
        },
      });
    },
    // 주소 먼저 확인하기
    async openAddress(applyId) {
      this.$emit('openInternetApplyAddress', applyId);
    },
    // 인터넷 견적서 열람하기
    async openVoucher(applyId) {
      this.$emit('openInternetApplyVoucher', applyId);
    },
    // 열람 전 인터넷 견적서 신청 취소하기 (사용자만 가능)
    async openApplyCancel(applyId) {
      this.$emit('openApplyCancelModal', applyId);
    },
    async getShopVouchersLimit(applyId) {
      var shopVouchers = await this[
        internetTypes.SELECT_INTERNET_APPLY_CHECK_LIMIT
      ]({
        applyId: applyId,
      });

      console.log('shopVouchers');
      console.log(shopVouchers);

      // this.shopVouchersCnt = shopVouchers.voucherCnt;
      this.shopVouchersLimit = shopVouchers.limit;
      this.userApplyCancel = shopVouchers.cancel;
    },
    setMasking(name) {
      var pattern = /.{2}$/; // 정규식
      return name.replace(pattern, '**');
    },
  },
};
</script>

<style></style>
